import { render, staticRenderFns } from "./VideoRenderingPlaceholder.vue?vue&type=template&id=471ddc4c&"
import script from "./VideoRenderingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./VideoRenderingPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports